import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { User, LayoutDashboard, LogOut, ChevronDown } from 'lucide-react';
import { Button } from '../ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../ui/dropdown-menu';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';

export const UserMenu = () => {
  const { t } = useApp();
  const { user, logout } = useAuth();
  const { toast } = useToast();
  const nav = useNavigate();

  if (!user) {
    return (
      <Link to="/signin"><Button variant="ghost" size="sm" className="text-[#3F3A30] hover:bg-[#FAF7F2]" data-testid="nav-signin"><User className="w-4 h-4 mr-1.5" /> {t('nav.signin')}</Button></Link>
    );
  }

  const onLogout = async () => { await logout(); toast({ title: t('auth.signedOut') }); nav('/'); };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-2 pl-1 pr-2 py-1 rounded-lg hover:bg-[#FAF7F2] transition-colors" data-testid="user-menu-button">
          <span className="w-8 h-8 rounded-full bg-[#0F8B5C] text-white text-xs font-bold flex items-center justify-center">{user.avatar}</span>
          <span className="text-sm font-medium text-[#1A1A1A] max-w-[120px] truncate" data-testid="user-menu-name">{user.name}</span>
          <ChevronDown className="w-3 h-3 opacity-60" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <div className="px-2 py-1.5 text-xs text-[#7A7468] truncate">{user.email}</div>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={() => nav('/dashboard')} data-testid="user-menu-dashboard"><LayoutDashboard className="w-4 h-4 mr-2" /> {t('nav.dashboard')}</DropdownMenuItem>
        <DropdownMenuItem onClick={onLogout} data-testid="user-menu-logout"><LogOut className="w-4 h-4 mr-2" /> {t('auth.logout')}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
